import "./FleetOperations.module.css";
import Header from "@/reusable_sections/Header";
import FastReliableFreightLogisticsInNorthMiami from "./sections/FastReliableFreightLogisticsInNorthMiami";
import TheFullServiceAdvantage from "./sections/TheFullServiceAdvantage";
import SupplyChainGallery from "./sections/SupplyChainGallery";
import Footer from "@/reusable_sections/Footer";
export default function FleetOperationsPage() {
  return <div>
      <Header />
      <FastReliableFreightLogisticsInNorthMiami />
      <TheFullServiceAdvantage />
      <SupplyChainGallery />
      <Footer />
    </div>;
}